export class DateToOrder {
    dateToDisplay: string;
    dayOfWeek: string;
    date: Date;
}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/model/DateToOrder.ts